// extracted by css-extract-rspack-plugin
export default {"icon":"icon-WpYgkp","desc":"desc-ktz2fz"};